export enum MedicalLabels {
  labelMedications = 'Current Medications',
  labelMedicalConditions = 'Health Conditions',
  labelMedicationAllergies = 'Medication Allergies',
}
